var _rect, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoodsGreenBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 25,
    viewBox: "0 0 32 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.84082,
    y: 0.904572,
    width: 30.6691,
    height: 23.1775,
    rx: 3,
    fill: "#77B77C"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.804,
    cy: 12.467,
    r: 4.3753,
    fill: "#1FDE00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoodsGreenBox);
export default __webpack_public_path__ + "static/media/GoodsGreenBox.8d6af8c2f0ccb0abd517e9f714ada743.svg";
export { ForwardRef as ReactComponent };